var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 417.006,
    height: 436.008,
    viewBox: "0 0 417.006 436.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-1437.872 -49.184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M1559.2,396.787a.874.874,0,0,1-1.194-.32l-1.881-3.256a.874.874,0,1,1,1.514-.875l1.881,3.256A.874.874,0,0,1,1559.2,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M1570.017,396.787a.874.874,0,0,1-1.194-.32l-7.286-12.618a.875.875,0,1,1,1.514-.876l7.286,12.619A.874.874,0,0,1,1570.017,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M1580.828,396.787a.875.875,0,0,1-1.195-.32l-12.691-21.982a.874.874,0,0,1,.32-1.195.864.864,0,0,1,.436-.118.875.875,0,0,1,.758.438l12.691,21.982A.873.873,0,0,1,1580.828,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M1591.64,396.787a.875.875,0,0,1-1.2-.32l-18.1-31.345a.875.875,0,0,1,.32-1.2.864.864,0,0,1,.436-.118.874.874,0,0,1,.758.438l18.1,31.345A.874.874,0,0,1,1591.64,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M1602.451,396.787a.874.874,0,0,1-1.194-.32l-23.5-40.708a.874.874,0,1,1,1.514-.875l23.5,40.708A.874.874,0,0,1,1602.451,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M1613.263,396.787a.874.874,0,0,1-1.194-.32l-28.91-50.071a.874.874,0,0,1,.32-1.2.872.872,0,0,1,1.194.32l28.91,50.071A.874.874,0,0,1,1613.263,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M1624.074,396.787a.875.875,0,0,1-1.195-.32l-34.314-59.434a.874.874,0,0,1,.319-1.195.863.863,0,0,1,.436-.118.876.876,0,0,1,.759.438l34.314,59.434A.873.873,0,0,1,1624.074,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M1634.886,396.787a.875.875,0,0,1-1.195-.32l-39.72-68.8a.874.874,0,0,1,.32-1.2.864.864,0,0,1,.436-.118.875.875,0,0,1,.758.438l39.72,68.8A.874.874,0,0,1,1634.886,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M1645.7,396.787a.874.874,0,0,1-1.194-.32l-45.126-78.16a.874.874,0,1,1,1.514-.875l45.126,78.16A.874.874,0,0,1,1645.7,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M1656.508,396.787a.874.874,0,0,1-1.194-.32l-50.531-87.523a.874.874,0,1,1,1.514-.875l50.531,87.523A.874.874,0,0,1,1656.508,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M1667.32,396.787a.875.875,0,0,1-1.195-.32l-55.937-96.886a.874.874,0,0,1,.32-1.2.864.864,0,0,1,.436-.118.874.874,0,0,1,.758.438l55.937,96.886A.873.873,0,0,1,1667.32,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M1678.132,396.787a.875.875,0,0,1-1.195-.32l-61.344-106.249a.875.875,0,0,1,.32-1.195.864.864,0,0,1,.436-.118.876.876,0,0,1,.759.438l61.343,106.249A.873.873,0,0,1,1678.132,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M1688.942,396.787a.874.874,0,0,1-1.194-.32L1621,280.855a.874.874,0,1,1,1.514-.875l66.748,115.612A.874.874,0,0,1,1688.942,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M1699.754,396.787a.874.874,0,0,1-1.194-.32l-72.155-124.974a.875.875,0,1,1,1.514-.876l72.155,124.975A.875.875,0,0,1,1699.754,396.787Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M1710.565,396.787a.875.875,0,0,1-1.195-.32L1631.811,262.13a.874.874,0,1,1,1.514-.875l77.559,134.337A.873.873,0,0,1,1710.565,396.787Z",
    fill: "#cce2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M1473.9,365.856a.437.437,0,1,1-.757-.437l.8-1.393a.436.436,0,0,1,.379-.219.43.43,0,0,1,.218.059.436.436,0,0,1,.16.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1476.216,369.862a.437.437,0,0,1-.757-.438l3.116-5.4a.436.436,0,0,1,.379-.219.43.43,0,0,1,.218.059.436.436,0,0,1,.16.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1478.528,373.866a.437.437,0,0,1-.757-.437l5.429-9.4a.433.433,0,0,1,.378-.219.428.428,0,0,1,.218.059.437.437,0,0,1,.161.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M1480.841,377.871a.437.437,0,0,1-.758-.437l7.742-13.408a.437.437,0,0,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M1483.153,381.876a.437.437,0,1,1-.757-.438l10.053-17.412a.437.437,0,0,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M1485.466,385.881a.437.437,0,1,1-.757-.438l12.364-21.417a.436.436,0,0,1,.379-.219.431.431,0,0,1,.218.059.436.436,0,0,1,.16.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M1487.778,389.886a.437.437,0,0,1-.757-.437l14.678-25.423a.434.434,0,0,1,.378-.219.428.428,0,0,1,.218.059.437.437,0,0,1,.161.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M1490.09,393.891a.437.437,0,0,1-.757-.437l16.99-29.428a.437.437,0,1,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M1492.4,397.9a.437.437,0,1,1-.757-.438l19.3-33.432a.437.437,0,0,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M1494.714,401.9a.437.437,0,0,1-.757-.438l21.614-37.437a.437.437,0,0,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M1497.026,405.906a.437.437,0,0,1-.757-.437l23.928-41.443a.433.433,0,0,1,.378-.219.428.428,0,0,1,.218.059.437.437,0,0,1,.161.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M1499.338,409.911a.437.437,0,0,1-.757-.438l26.24-45.447a.435.435,0,0,1,.378-.219.428.428,0,0,1,.218.059.437.437,0,0,1,.161.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M1501.651,413.916a.438.438,0,0,1-.758-.438l28.552-49.452a.437.437,0,0,1,.757.437Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M1503.964,417.92a.437.437,0,1,1-.757-.437l30.863-53.457a.436.436,0,0,1,.379-.219.43.43,0,0,1,.218.059.436.436,0,0,1,.16.6Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M1506.276,421.926a.437.437,0,0,1-.757-.438l33.175-57.462a.436.436,0,0,1,.379-.219.431.431,0,0,1,.218.059.436.436,0,0,1,.16.6Z",
    fill: "#cce2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M1439.15,292.165a.435.435,0,0,1-.6-.16l-.621-1.074a.438.438,0,0,1,.159-.6.45.45,0,0,1,.219-.059.438.438,0,0,1,.379.219l.621,1.075A.438.438,0,0,1,1439.15,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1442.717,292.165a.434.434,0,0,1-.6-.16l-2.405-4.164a.437.437,0,0,1,.757-.438l2.4,4.165A.438.438,0,0,1,1442.717,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M1446.285,292.165a.434.434,0,0,1-.6-.16l-4.189-7.255a.437.437,0,1,1,.757-.437l4.189,7.255A.437.437,0,0,1,1446.285,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1449.853,292.165a.434.434,0,0,1-.6-.16l-5.973-10.345a.437.437,0,0,1,.757-.438l5.973,10.346A.436.436,0,0,1,1449.853,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M1453.421,292.165a.434.434,0,0,1-.6-.16l-7.757-13.435a.437.437,0,1,1,.757-.437l7.757,13.435A.436.436,0,0,1,1453.421,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1456.989,292.165a.435.435,0,0,1-.6-.16l-9.541-16.525a.437.437,0,1,1,.757-.438l9.542,16.526A.437.437,0,0,1,1456.989,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M1460.557,292.165a.433.433,0,0,1-.6-.16l-11.326-19.615a.437.437,0,0,1,.161-.6.428.428,0,0,1,.218-.059.434.434,0,0,1,.378.218l11.326,19.616A.437.437,0,0,1,1460.557,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1464.126,292.165a.434.434,0,0,1-.6-.16l-13.11-22.705a.437.437,0,1,1,.757-.438l13.11,22.706A.438.438,0,0,1,1464.126,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M1467.694,292.165a.434.434,0,0,1-.6-.16l-14.894-25.8a.438.438,0,1,1,.758-.438l14.893,25.8A.437.437,0,0,1,1467.694,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M1471.262,292.165a.434.434,0,0,1-.6-.16l-16.677-28.886a.436.436,0,0,1,.16-.6.431.431,0,0,1,.218-.059.436.436,0,0,1,.379.219l16.677,28.886A.436.436,0,0,1,1471.262,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M1474.83,292.165a.435.435,0,0,1-.6-.16l-18.461-31.976a.436.436,0,0,1,.16-.6.43.43,0,0,1,.218-.059.436.436,0,0,1,.379.219l18.461,31.976A.436.436,0,0,1,1474.83,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M1478.4,292.165a.433.433,0,0,1-.6-.16l-20.246-35.066a.437.437,0,0,1,.757-.438l20.246,35.067A.437.437,0,0,1,1478.4,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M1481.966,292.165a.433.433,0,0,1-.6-.16l-22.03-38.156a.437.437,0,0,1,.16-.6.444.444,0,0,1,.218-.059.438.438,0,0,1,.379.219l22.03,38.157A.437.437,0,0,1,1481.966,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M1485.535,292.165a.434.434,0,0,1-.6-.16l-23.813-41.246a.437.437,0,1,1,.757-.437l23.813,41.246A.438.438,0,0,1,1485.535,292.165Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M1489.1,292.165a.435.435,0,0,1-.6-.16l-25.6-44.336a.437.437,0,0,1,.757-.438l25.6,44.337A.436.436,0,0,1,1489.1,292.165Z",
    fill: "#cce2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M1780.525,178.2h-5.112a.875.875,0,0,1,0-1.75h5.112a.875.875,0,0,1,0,1.75Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M1787.872,165.474h-19.806a.875.875,0,0,1,0-1.75h19.806a.875.875,0,0,1,0,1.75Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M1795.22,152.747h-34.5a.874.874,0,1,1,0-1.749h34.5a.874.874,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M1802.568,140.02h-49.2a.875.875,0,0,1,0-1.75h49.2a.875.875,0,0,1,0,1.75Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M1809.916,127.293h-63.893a.875.875,0,1,1,0-1.749h63.893a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M1817.264,114.566h-78.59a.875.875,0,1,1,0-1.749h78.59a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M1824.612,101.84h-93.285a.875.875,0,1,1,0-1.749h93.285a.874.874,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M1831.959,89.113H1723.98a.875.875,0,1,1,0-1.749h107.979a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M1839.307,76.386H1716.631a.875.875,0,1,1,0-1.749h122.676a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M1846.655,63.659H1709.284a.875.875,0,1,1,0-1.749h137.371a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M1854,50.933H1701.935a.875.875,0,1,1,0-1.749H1854a.875.875,0,1,1,0,1.749Z",
    fill: "#cce2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M1675.826,264.477a.437.437,0,0,0-.379-.656h-15.679a.437.437,0,0,0-.379.656l7.839,13.579a.455.455,0,0,0,.757,0Zm-1.137.219-7.082,12.266-7.081-12.266Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M1657.992,457.072a.438.438,0,0,0-.378-.656h-32.235a.438.438,0,0,0-.379.656l16.117,27.917a.455.455,0,0,0,.757,0Zm-1.135.219L1641.5,483.9l-15.36-26.605Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M1843.817,400.412a.872.872,0,0,0,0-.875l-29.734-51.5a.874.874,0,0,0-1.514,0l-29.733,51.5a.875.875,0,0,0,.757,1.312h59.467A.873.873,0,0,0,1843.817,400.412Zm-2.272-1.312h-56.437l28.218-48.876Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M1752.547,160.535a.437.437,0,0,0,0-.437l-26.54-45.968a.437.437,0,0,0-.757,0L1698.711,160.1a.437.437,0,0,0,.378.656h53.079A.438.438,0,0,0,1752.547,160.535Zm-1.136-.656h-51.565l25.783-44.656Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M1702.532,181.6a.874.874,0,0,0-.757-1.312H1686.1a.874.874,0,0,0-.757,1.312l7.84,13.579a.874.874,0,0,0,1.514,0Zm-2.272.437-6.324,10.954-6.325-10.954Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M1469.553,373.016a.878.878,0,0,0,0-.876l-7.841-13.578a.874.874,0,0,0-1.514,0l-7.839,13.578a.875.875,0,0,0,.757,1.313h15.68A.875.875,0,0,0,1469.553,373.016Zm-2.273-1.313h-12.649l6.324-10.954Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M1790.3,352.229a.438.438,0,0,0-.378-.656h-22.312a.438.438,0,0,0-.378.656l11.155,19.323a.455.455,0,0,0,.757,0Zm-1.135.219-10.4,18.011-10.4-18.011Z",
    fill: "#cce2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M1641.88,198.3a.437.437,0,0,0-.379-.656h-90.526a.437.437,0,0,0-.379.656l45.263,78.4a.455.455,0,0,0,.757,0Zm-1.136.219L1596.237,275.6l-44.505-77.088Z",
    fill: "#cce2ff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg-1.d6b79be6db5dc41611e5d7f43a1a28a1.svg";
export { ForwardRef as ReactComponent };